// src/global.js
window.global = window;
